import React               from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import IconEnoughStock           from 'images/bom/stock.png'
import IconNoEnoughStock         from 'images/bom/no-enough-stock.png'
import IconNoStock               from 'images/bom/no-stock.png'
import IconNoPerfectMatch        from 'images/bom/no-perfect-match.png'
import IconNotFound              from 'images/bom/not-found.png'
import IconSubstitutePart        from 'images/bom/substitute-part.png'
import IconUnknownMountingType   from 'images/bom/unknown-mounting-type.png'

export default (props) => {
  const { showSummary } = props
  if (!showSummary) return null;
  
  var assembly_report = {}
  var part_status = {}
  var selected_quantity = props.selected_quantity;

  if (props.selected_quantity === undefined ){
    selected_quantity = props.quote.quantities[0];
  }

  if (props.quote.report !== undefined 
       && Object.keys(props.quote.report).length !== 0 ){
    assembly_report = props.quote.report.assembly_parameters;
    part_status = props.quote.report.status[selected_quantity];
  }

  return (
    <div className="parameters-summary">
      <div>
        <strong>Your BOM File : </strong>
        {props.quote.filename}
      </div>
      <table className="table table-bordered parameters-summary-table">
        <tbody>
          <tr>
            <td className="icon"></td>
            <td className="key">Bom Line Items:  </td>
            <td className="value"> {("bom_line_items" in assembly_report) ? assembly_report.bom_line_items : ""} </td>
          </tr>
          <tr>
            <td className="icon">
              <img className="icon-bom-admin" src={IconEnoughStock} alt="Perfect Match" />
            </td>
            <td className="key">Enough Stock</td>
            <td className="value"> {("enough_stock" in part_status) ? part_status.enough_stock : ""} </td>
          </tr>
          <tr>
            <td className="icon">
              <img className="icon-bom-admin" src={IconNoEnoughStock} alt="Not Enought Stock" />
            </td>
            <td className="key">No Enough Stock</td>
            <td className="value"> {("no_enough_stock" in part_status) ? part_status.no_enough_stock : ""} </td>
          </tr>
          <tr>
            <td className="icon">
              <img className="icon-bom-admin" src={IconNoStock} alt="No Result" />
            </td>
            <td className="key">No Stock</td>
            <td className="value"> {("no_stock" in part_status) ? part_status.no_stock : ""} </td>
          </tr>
          <tr>
            <td className="icon">
              <img className="icon-bom-admin" src={IconUnknownMountingType} alt="Unknown Mounting Type" />
            </td>
            <td className="key">Unknown Mounting Type</td>
            <td className="value"> {("unknown_mounting_type" in assembly_report) ? assembly_report.unknown_mounting_type : ""} </td>
          </tr>
          <tr>
            <td className="icon">
              <img className="icon-bom-admin" src={IconSubstitutePart} alt="Substitute Part" />
            </td>
            <td className="key">Substitute Parts</td>
            <td className="value"> {("substitute" in part_status) ? part_status.substitute : ""} </td>
          </tr>
          <tr>
            <td className="icon"></td>
            <td className="key">Buy Parts</td>
            <td className="value"> {("buy_parts" in part_status) ? part_status.buy_parts : ""} </td>
          </tr>
          <tr>
            <td className="icon"></td>
            <td className="key">Do not install</td>
            <td className="value"> {("no_install_parts" in part_status) ? part_status.no_install_parts : ""} </td>
          </tr>
          <tr>
            <td className="icon"></td>
            <td className="key">I will provide</td>
            <td className="value"> {("will_provide_parts" in part_status) ? part_status.will_provide_parts : ""} </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
